import {useMemo} from "react";

export const useSchedulerMenuOptions = ({menusConfig}) => {
    return useMemo(() => {
        return [...(menusConfig || [])]
            .sort((a, b) => {
                if (a.standard === b.standard) {
                    return a.name.localeCompare(b.name, undefined, {numeric: true});
                }
                return a.standard ? -1 : 1;
            })
            .map((m) => ({value: m, label: m.name, isStandard: m.standard}));
    }, [menusConfig]);
}